import React from 'react'
import { PaymentInterval, RecurlyPrice } from './Recurly'
import { UpgradeTideways6 } from './UpgradeTideways6'

interface Props {
    recurlyPricing: any
    upgrade: UpgradeTideways6
    onPlanChange: (plan: string) => void
    selectedPlan: string
    interval: PaymentInterval
}
interface StateProps {
    [key: string]: RecurlyPrice
}

class SelectTideways6Plans extends React.Component<Props, StateProps> {
    constructor(props: Props) {
        super(props)

        this.state = {}
    }
    public componentDidMount() {
        this.props.upgrade.availablePlans.map(planChoice => {
            const planCode = planChoice.name
            const plan = this.props.interval === PaymentInterval.Yearly ? planCode + '_1y' : planCode
            let pricing = this.props.recurlyPricing.plan(plan)
            pricing = pricing.currency(this.props.upgrade.currency)

            pricing.done((price: any) => {
                this.setState({ [planCode]: price })
            })
        })
    }

    public render() {
        const paymentPeriodName = this.props.interval === PaymentInterval.Monthly ? 'month' : 'year'

        return (
            <div className="row">
                {this.props.upgrade.availablePlans.map(plan => {
                    if (!this.state[plan.name]) {
                        return null
                    }
                    const price = this.state[plan.name]
                    const historyRetention = {
                        5: '6 weeks',
                        14: '15 months',
                        30: 'Unlimited',
                    }[plan.retentionDays]

                    return (
                        <div key={plan.name} className="col-lg-4">
                            <div className="box">
                                <div className="box-header">
                                    <h3 className="box-title">{plan.label}</h3>
                                </div>
                                <div className="box-body" style={{ fontSize: '12pt', minHeight: '465px' }}>
                                    <div className="centered" style={{ fontSize: '14pt' }}>
                                        <small>Starts at</small>{' '}
                                        <strong>
                                            <big>
                                                {price.base.plan.unit} {price.currency.symbol}
                                            </big>
                                        </strong>
                                        <small> / {paymentPeriodName}</small>
                                    </div>
                                    <div className="centered">
                                        add more projects for {price.base.addons.apm_extra_boosters} {price.currency.symbol} /{' '}
                                        {paymentPeriodName}
                                    </div>
                                    <div className="centered" style={{ marginBottom: '10px' }}>
                                        and increase project limits for {price.base.addons.apm_extra_boosters} {price.currency.symbol} /{' '}
                                        {paymentPeriodName}
                                    </div>
                                    <div className="centered" style={{ height: '50px' }}>
                                        {plan.name === this.props.selectedPlan && <p className="pt-8 label label-success">Selected Plan</p>}

                                        {this.getPlanRank(plan.name) > this.getPlanRank(this.props.selectedPlan) && (
                                            <button className="btn btn-primary" onClick={() => this.props.onPlanChange(plan.name)}>
                                                Upgrade to {plan.label}
                                            </button>
                                        )}

                                        {this.getPlanRank(plan.name) < this.getPlanRank(this.props.selectedPlan) && (
                                            <button className="btn btn-default" onClick={() => this.props.onPlanChange(plan.name)}>
                                                Downgrade to {plan.label}
                                            </button>
                                        )}
                                    </div>
                                    <ul>
                                        <li>All Features</li>
                                        <li>{plan.retentionDays} days of data retention</li>
                                        <li>{historyRetention} history</li>
                                        <li>Basic {plan.advancedIntegrations && <span>&amp; Advanced</span>} Integrations</li>
                                        <li>GitHub {plan.premium && <span>&amp; Azure AD</span>} SSO</li>
                                        {plan.wireTransfer && (
                                            <li>Payment via Wire Transfer (Yearly), Offer Letters and P/O numbers on invoices</li>
                                        )}
                                        {plan.includedTeams > 1 && <li>{plan.includedTeams} Teams for Team-based Access Control</li>}
                                        {plan.premium && <li>Onboarding Workshops</li>}
                                        {plan.premium && <li>Priority Handling in Support</li>}
                                        {plan.premium && <li>Security Questionaires, other Vendor Forms, Custom DPA terms</li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    private getPlanRank(plan: string) {
        if (plan.includes('starter')) {
            return 1
        } else if (plan.includes('basic')) {
            return 2
        } else if (plan.includes('standard')) {
            return 3
        } else if (plan.includes('pro')) {
            return 4
        }
        return 0
    }
}

export default SelectTideways6Plans
